import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import idTranslation from './locales/id/translation.json';

// Get the language from localStorage, if it exists
const savedLanguage = localStorage.getItem('lang') || 'id';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation
    },
    id: {
      translation: idTranslation
    }
  },
  lng: savedLanguage, // Default language
  fallbackLng: 'en', // Fallback language if the selected language is not available
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
